var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader__container"},[_c('div',{staticClass:"loader triangle"},[_c('svg',{attrs:{"viewBox":"0 0 86 80"}},[_c('polygon',{attrs:{"points":"43 8 79 72 7 72"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }